import React from 'react';
import * as S from './style';
import { getMenuIcon } from './icons';

export const MegaMenuPanel = ({ items, columns }) => {
  if (!items?.length) return null;

  // O menu mobile passa columns={1}; no desktop mantém o cálculo original.
  const resolvedColumns = columns ?? (items.length > 4 ? 3 : 2);

  return (
    <S.Panel columns={resolvedColumns}>
      {items.map((subItem, index) => {
        const Icon = getMenuIcon(subItem?.tituloSubmenu);

        return (
          <S.Card key={index} to={subItem?.rotaSubmenu}>
            <S.IconCircle>
              <Icon />
            </S.IconCircle>
            <S.CardText>
              <strong>{subItem?.tituloSubmenu}</strong>
              {subItem?.Descricao && <span>{subItem.Descricao}</span>}
            </S.CardText>
          </S.Card>
        );
      })}
    </S.Panel>
  );
};
